var render = function render(){var _vm=this,_c=_vm._self._c;return _c('order-modal-row-layout',[_c('template',{slot:"icon"},[_vm._v("   ")]),_vm._v(" "),_c('template',{slot:"content"},[_c('a-row',{attrs:{"type":"flex"}},[_c('a-col',{attrs:{"span":12}},[_c('order-delivery-estimation',{attrs:{"package":_vm.package,"price":_vm.price}})],1)],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }